export const GET_PRODUCT_LINE = 'CCM.GET_PRODUCT_LINE'
export const PRODUCT_LINE_SHOW_LINE = 'CCM.PRODUCT_LINE_SHOW_LINE'
export const PRODUCT_LINE_SELECT_PRODUCT = 'CCM.PRODUCT_LINE_SELECT_PRODUCT'
export const PRODUCT_LINE_SELECT_AGE_GROUP = 'CCM.PRODUCT_LINE_SELECT_AGE_GROUP'
export const PRODUCT_LINE_SELECT_LINE = 'CCM.PRODUCT_LINE_SELECT_LINE'
export const PRODUCT_LINE_SELECT_LOCATION = 'CCM.PRODUCT_LINE_SELECT_LOCATION'
export const PRODUCT_LINE_SELECT_VARIATION = 'CCM.PRODUCT_LINE_SELECT_VARIATION'
export const PRODUCT_LINE_SELECT_VERSION = 'CCM.PRODUCT_LINE_SELECT_VERSION'
